/* Sunny Stripes - aeration, dethatching, overseeding & hydroseeding quote.
   The four services this page is about are each selectable; compost
   topdressing is the add-on that takes 10% off itself and the aeration work
   beside it. Aeration + overseeding chosen together price as one job at the
   better combined rate. No price is set in this file - see ss-rates.js. */
(function(){
  "use strict";

  /* ======================================================================
     PRICES COME FROM assets/ss-rates.js — THE ONE RATE CARD.
     Nothing in this file sets a price. Edit ss-rates.js and every quote
     builder on the site changes together; that is the whole point.
     ====================================================================== */
  var SS = window.SS_RATES;
  if (!SS) {
    console.error("Sunny Stripes: ss-rates.js did not load — the aeration quote tool cannot price anything. Check that snippets/aeration-tool.liquid renders it before this file.");
    return;
  }
  var BUNDLE = SS.bundleDiscount;

  /* Klaviyo - the durable lead record. Public key, no captcha, no CORS. */
  var KLAVIYO = { publicApiKey:"SKBLA9" };

  /* Google Places - same key and Sheboygan County bounds as the other tools.
     A bounds box is required: the new Places API rejects {center,radius} for
     locationRestriction and the whole autocomplete call dies silently. */
  var GOOGLE = {
    apiKey: "AIzaSyB8JkZAqLw39qEuj3FKGUsVQ9Yzp5mIAck",
    center: { lat:43.75, lng:-87.75 },
    bounds: { west:-88.20, south:43.53, east:-87.58, north:43.90 },
    region: "us", state: "WI", county: "sheboygan"
  };
  var TOWNS = ["Adell","Cascade","Cedar Grove","Elkhart Lake","Glenbeulah","Howards Grove",
               "Kohler","Oostburg","Plymouth","Random Lake","Sheboygan","Sheboygan Falls",
               "Waldo","Town of Wilson"];
  var SERVICE_CITIES = TOWNS.map(function(t){ return t.toLowerCase(); }).concat(["wilson"]);

  function buildTowns(){
    var sel = document.getElementById("aocity");
    if (!sel) return;
    sel.innerHTML = '<option value="">Select…</option>' +
      TOWNS.map(function(t){ return '<option>' + t + '</option>'; }).join("") +
      '<option value="other">Other Sheboygan County town</option>';
  }

  /* Size cards are shared too, so "Large" means the same lawn everywhere. */
  var TIERS = SS.tiers;

  var S = {
    step:1, ptype:"residential",
    tierRes:"m", tierCom:"l",
    mode:"cards", sqft:null, mapSqft:null, placeLoc:null,
    aerate:true, overseed:true, dethatch:false, hydro:false, touchup:false, topdress:false, irrigate:false,
    outOfArea:false
  };

  var IRR_COPY = "Watering is the single biggest variable in whether new seed takes, and the one part we can&rsquo;t do from the seat of a machine &mdash; so we take it off your hands. Hoses, sprinklers and timers supplied, set up the day we seed, checked every couple of days and adjusted as the weather changes, then removed once the stand is established.";
  var $ = function(id){ return document.getElementById(id); };
  /* The irrigation tile is built here rather than in aeration-tool.liquid, so
     the offer ships with the code that prices it. If the tile is ever moved
     into the snippet, this sees it there and does nothing. */
  (function(){
    if ($("aosvcIr") || !$("aosvcTd")) return;
    var d = document.createElement("div");
    d.className = "svc"; d.id = "aosvcIr"; d.setAttribute("data-svc", "irrigate");
    d.innerHTML = '<span class="box">&#10003;</span><span class="meta">' +
      '<span class="t">Temporary irrigation setup &middot; about 4 weeks</span>' +
      '<span class="d">' + IRR_COPY + '</span>' +
      '<span class="tagline" id="aoIrTag">Available with overseeding</span></span>' +
      '<span class="amt" id="aoaIr">&mdash;<small>add-on</small></span>';
    $("aosvcTd").parentNode.insertBefore(d, $("aosvcTd").nextSibling);
  })();
  var money = function(n){ return "$" + Math.round(n).toLocaleString("en-US"); };
  var sqftTxt = function(n){ return Math.round(n).toLocaleString("en-US") + " sq ft"; };
  var esc = function(s){ return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); };
  var isCom = function(){ return S.ptype === "commercial"; };
  function hideErr(id){ var e = $(id); if (e) e.style.display = "none"; }
  function tierKey(){ return isCom() ? S.tierCom : S.tierRes; }
  function tierBy(k){ for (var i=0;i<TIERS.length;i++){ if (TIERS[i].k === k) return TIERS[i]; } return TIERS[1]; }
  function currentTier(){ return tierBy(tierKey()); }

  var P = SS.price;   /* P("aerseed", sqft) */

  function area(){
    if (S.mode === "sqft") return S.sqft ? Math.max(500, S.sqft) : null;
    if (S.mode === "map")  return S.mapSqft ? Math.max(500, S.mapSqft) : null;
    var t = currentTier();
    return t.custom ? null : t.area;
  }

  var r5 = SS.round5;

  function quote(){
    var a = area();
    if (a === null) return { custom:true, area:null, total:null };

    /* Aeration + overseeding together are one job at the combined rate;
       either one alone is priced on its own card. */
    var both = S.aerate && S.overseed;
    var turf = both ? P("aerseed", a)
             : S.aerate   ? P("aerate", a)
             : S.overseed ? P("overseed", a) : 0;

    var td  = S.topdress ? P("topdress", a) : 0;
    var de  = S.dethatch ? P("dethatch", a) : 0;
    var tou = S.touchup ? P("touchup", a) : 0;
    /* Irrigation only exists alongside overseeding - see `irrigation` in
       ss-rates.js. Past an acre price() returns null and it is quoted on site. */
    var irrOk  = S.overseed;
    var irrRaw = P("irrigation", a);
    var irrWant = S.irrigate && irrOk;
    var irr = (irrWant && irrRaw != null) ? irrRaw : 0;

    /* The bundle is topdressing plus the aeration work it rides along with.
       Topdressing on its own is not discounted. */
    var save = (S.topdress && turf) ? (turf + td) * BUNDLE : 0;

    var turfShown = turf ? r5(turf) : 0;
    var r = {
      custom:false, area:a, both:both,
      turf: turfShown,
      turfLabel: both ? "Core aeration + overseeding" : S.aerate ? "Core aeration" : S.overseed ? "Overseeding" : "",
      rate: turf ? Math.round(turfShown/(a/1000)) : 0,
      aerateShown:   r5(P("aerate", a)),
      overseedShown: r5(P("overseed", a)),
      dethatchShown: r5(P("dethatch", a)),
      topdressShown: r5(P("topdress", a)),
      /* The touch-up scales with the lawn now - 60% of that lawn's overseeding,
         floored - where it used to be one flat $325. It rounds to $5 like every
         other figure here; it was the one line that did not. */
      touchupShown:  r5(P("touchup", a)),
      topdress: r5(td),
      dethatch: r5(de),
      touchup: r5(tou),
      irrigationShown: irrRaw == null ? null : r5(irrRaw),
      irrigation: r5(irr),
      irrigationQuote: irrWant && irrRaw == null,
      irrigationOk: irrOk,
      hydro: S.hydro,
      save: r5(save),
      atMin: turf > 0 && SS.atMin(both ? "aerseed" : S.aerate ? "aerate" : "overseed", a)
    };
    r.sub = r.turf + r.topdress + r.dethatch + r.touchup + r.irrigation;
    r.total = r.sub - r.save;
    r.any = !!(S.aerate || S.overseed || S.dethatch || S.hydro || S.touchup || S.topdress || (S.irrigate && S.overseed));
    return r;
  }

  /* ---------------- property type ---------------- */
  function setPtype(pt){
    S.ptype = pt;
    $("aoptRes").classList.toggle("on", pt === "residential");
    $("aoptCom").classList.toggle("on", pt === "commercial");
    $("aocomMsg").style.display = isCom() ? "flex" : "none";
    $("aosizeLbl").textContent = isCom() ? "How much turf are we aerating?" : "How big is your lawn?";
    $("aoaddr").placeholder = isCom() ? "1000 Highland Dr" : "123 N 8th St";
    $("aosizeHint").innerHTML = isCom()
      ? "Not sure? Pick the closest — we confirm the real turf area on site before quoting."
      : "Not sure? Most homes here land on <b>Medium</b>. To measure it yourself, open " +
        "<a href=\"https://www.google.com/maps\" target=\"_blank\" rel=\"noopener\">Google Maps</a>, " +
        "right-click your lawn and choose “Measure distance”.";
    buildLots(); render();
  }

  function buildLots(){
    var sel = tierKey(), com = isCom();
    $("aolots").innerHTML = TIERS.map(function(t){
      var on = (sel === t.k && S.mode === "cards");
      return '<div class="lot' + (on ? " sel" : "") + (t.custom ? " custom" : "") + '" data-k="'+t.k+'">' +
             '<span class="tick">✓</span>' +
             '<div class="nm">'+t.nm+'</div>' +
             '<div class="sz">'+t.sz+'</div>' +
             '<div class="hint">'+(com ? t.com : t.res)+'</div>' +
             '</div>';
    }).join("");
  }

  function render(){
    var q = quote();
    var custom = !!q.custom;
    var pending = custom && S.mode !== "cards";

    $("aoareaRead").innerHTML = pending
      ? ""
      : (custom
          ? "We'll measure this one on site — 3+ acre properties are quoted per property."
          : "Estimated turf area: <b>" + sqftTxt(q.area) + "</b>");
    if (S.mode === "sqft"){
      $("aosqftRead").innerHTML = S.sqft
        ? ("Pricing <b>" + sqftTxt(q.area) + "</b> at an average of $" + q.rate + " per 1,000 sq ft.")
        : "Enter the square footage of lawn you want aerated.";
    }

    /* step 2 tiles */
    $("aoaAe").innerHTML = custom ? '—<small>one-time</small>'
      : money(q.aerateShown) + '<small>one-time</small>';
    $("aoaOs").innerHTML = custom ? '—<small>one-time</small>'
      : money(q.overseedShown) + '<small>' + (q.both ? 'in the pair price' : 'one-time') + '</small>';
    $("aoaDe").innerHTML = custom ? '—<small>one-time</small>'
      : money(q.dethatchShown) + '<small>one-time</small>';
    $("aoaTd").innerHTML = custom ? '—<small>add-on</small>'
      : money(q.topdressShown) + '<small>add-on</small>';
    /* Filled in here rather than left in the markup. It was hard-coded as
       "$325 flat" in aeration-tool.liquid and nothing ever overwrote it, so
       when the touch-up started scaling with lawn size on 2026-09-01 the tile
       went on advertising $325 while the estimate beside it billed $165. A
       price that lives in markup is a price nobody remembers to change. */
    $("aoaTou").innerHTML = custom ? '—<small>next season</small>'
      : money(q.touchupShown) + '<small>next season</small>';
    $("aosvcAe").classList.toggle("on", S.aerate);
    $("aosvcOs").classList.toggle("on", S.overseed);
    $("aosvcDe").classList.toggle("on", S.dethatch);
    $("aosvcHy").classList.toggle("on", S.hydro);
    $("aoaIr").innerHTML = (custom || q.irrigationShown == null) ? 'Quote<small>on site</small>'
      : money(q.irrigationShown) + '<small>add-on</small>';
    $("aosvcTou").classList.toggle("on", S.touchup);
    /* Greyed out, not hidden, when overseeding is off - so the offer is still
       seen and the reason it is unavailable is right there on the tile. */
    var irOk = custom ? S.overseed : q.irrigationOk;
    $("aosvcIr").classList.toggle("on", S.irrigate && irOk);
    $("aosvcIr").style.opacity = irOk ? "" : ".55";
    $("aoIrTag").textContent = irOk ? "Keeps new seed watered while it establishes" : "Available with overseeding";
    $("aosvcTd").classList.toggle("on", S.topdress);

    if (pending){
      $("aoEstHead").textContent = "$0";
      $("aoEstArea").textContent = S.mode === "map"
        ? "Trace your lawn on the map to price it"
        : "Enter your turf square footage";
      $("aomAmt").innerHTML = "$0<small>your estimate</small>";
      $("aoEstItems").innerHTML = "";
      $("aoEstTotals").style.display = "none";
      $("aoFlagMin").classList.remove("show");
      $("aoFlagBig").classList.remove("show");
      return;
    }

    if (custom){
      $("aoEstHead").textContent = "Custom quote";
      $("aoEstArea").textContent = "3+ acres";
      $("aomAmt").innerHTML = "Custom<small>we'll scope it</small>";
      $("aoEstItems").innerHTML = '<div class="item"><span class="nm">Large parcel<small>Aeration at this scale is priced per property and usually phased across visits.</small></span></div>';
      $("aoEstTotals").style.display = "none";
      $("aoFlagMin").classList.remove("show");
      $("aoFlagBig").textContent = "Tell us about the property and we'll walk it, measure it and put a fixed price in writing.";
      $("aoFlagBig").classList.add("show");
      return;
    }

    $("aoEstHead").textContent = money(q.total);
    $("aoEstArea").textContent = sqftTxt(q.area) + " of turf";
    $("aomAmt").innerHTML = money(q.total) + "<small>your estimate</small>";

    var items = "";
    if (q.turf) items += '<div class="item"><span class="nm">' + q.turfLabel + '<small>over ' + sqftTxt(q.area) + '</small></span><span class="amt">' + money(q.turf) + '</span></div>';
    if (q.dethatch) items += '<div class="item"><span class="nm">Dethatching<small>raked out and hauled away</small></span><span class="amt">' + money(q.dethatch) + '</span></div>';
    if (q.topdress) items += '<div class="item"><span class="nm">Compost topdressing<small>¼″ · same visit</small></span><span class="amt">' + money(q.topdress) + '</span></div>';
    if (q.touchup)  items += '<div class="item"><span class="nm">Next-season touch-up<small>overseed, locked price</small></span><span class="amt">' + money(q.touchup) + '</span></div>';
    if (q.irrigation) items += '<div class="item"><span class="nm">Temporary irrigation<small>about 4 weeks, set up and removed</small></span><span class="amt">' + money(q.irrigation) + '</span></div>';
    if (q.irrigationQuote) items += '<div class="item"><span class="nm">Temporary irrigation<small>priced on site at this size</small></span><span class="amt">Quote</span></div>';
    if (q.hydro)    items += '<div class="item"><span class="nm">Hydroseeding<small>quoted after we see the site</small></span><span class="amt">Quote</span></div>';
    if (q.save)     items += '<div class="item disc"><span class="nm">Bundle savings<small>aeration + topdressing</small></span><span class="amt">−' + money(q.save) + '</span></div>';
    if (!items) items = '<div class="item"><span class="nm">Nothing selected yet<small>Tick a service above to price it.</small></span></div>';
    $("aoEstItems").innerHTML = items;

    $("aoEstTotals").style.display = "block";
    $("aoTSub").textContent = money(q.sub);
    $("aoLnBundle").style.display = q.save ? "flex" : "none";
    $("aoTBundle").textContent = "−" + money(q.save);
    $("aoTGrand").textContent = money(q.total);

    $("aoFlagMin").classList.toggle("show", q.atMin && !isCom());
    var big = $("aoFlagBig");
    if (isCom()){
      big.textContent = "Commercial turf is contract-priced on route-based volume. This is a starting point — we walk the property before quoting.";
      big.classList.add("show");
    } else if (q.hydro){
      big.textContent = "Hydroseeding is priced per property. We'll include a figure for it when we confirm your estimate.";
      big.classList.add("show");
    } else {
      big.textContent = "Large property — call and we'll phase it across two visits.";
      big.classList.toggle("show", q.area >= 25000);
    }
  }

  /* ---------------- step nav ---------------- */
  function show(n){
    if (n === 2 && !validate(1)) return;
    if (n === 3){ if (!validate(1)) { n = 1; } else if (!validate(2)) { return; } }
    S.step = n;
    ["ap1","ap2","ap3"].forEach(function(id,i){ $(id).style.display = (i+1===n) ? "block" : "none"; });
    $("apDone").style.display = "none";
    var sts = $("aosteps").children;
    for (var i=0;i<sts.length;i++){
      sts[i].classList.toggle("active", i+1===n);
      sts[i].classList.toggle("done", i+1<n);
    }
    $("aofill").style.width = (n/3*100) + "%";
    $("aomBtn").textContent = n===1 ? "Choose the work →" : (n===2 ? "Get my quote →" : "Send my request →");
    var t = document.getElementById("aotool");
    if (t) window.scrollTo({ top: t.offsetTop - 20, behavior:"smooth" });
  }

  function validate(n){
    if (n === 2){
      var e2 = $("aoe2"), any = quote().any;
      e2.style.display = any ? "none" : "block";
      e2.textContent = "Pick at least one service to price.";
      return any;
    }
    if (n === 1){
      var bad = [], addr = $("aoaddr"), city = $("aocity");
      [addr, city].forEach(function(el){
        var empty = !el.value.trim();
        el.classList.toggle("bad", empty);
        if (empty) bad.push(el);
      });
      if (S.mode === "sqft" && !S.sqft){ $("aosqft").classList.add("bad"); bad.push($("aosqft")); }
      var needsTrace = (S.mode === "map" && !S.mapSqft);
      var e = $("aoe1");
      if (S.outOfArea){
        addr.classList.add("bad");
        e.style.display = "block";
        e.textContent = "That address is outside Sheboygan County — we're not able to take it on. " +
                        "Call us at (920) 943-6422 if you think that's wrong.";
        return false;
      }
      e.style.display = (bad.length || needsTrace) ? "block" : "none";
      e.textContent = needsTrace && !bad.length
        ? "Trace your lawn on the map, or switch to “Pick a size”."
        : "Add your street address and city so we can confirm you're in our service area.";
      if (needsTrace && !bad.length) return false;
      if (bad.length) bad[0].focus();
      return !bad.length;
    }
    if (n === 3){
      var need = ["aofname","aoemail","aophone"], miss = [];
      need.forEach(function(id){
        var el = $(id), empty = !el.value.trim();
        el.classList.toggle("bad", empty);
        if (empty) miss.push(el);
      });
      var em = $("aoemail");
      if (em.value.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())){ em.classList.add("bad"); miss.push(em); }
      var e3 = $("aoe3");
      e3.style.display = miss.length ? "block" : "none";
      e3.textContent = "We need a name, a working email and a phone number to get back to you.";
      if (miss.length) miss[0].focus();
      return !miss.length;
    }
    return true;
  }

  /* ---------------- address autocomplete ---------------- */
  var AC = { ready:false, lib:null, token:null, sug:[], active:-1, timer:null };
  var PIN = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';

  function loadMaps(){
    if (window.google && window.google.maps && window.google.maps.importLibrary) return initAC();
    if (document.getElementById("ao-gmaps")) return;
    window.__aoGmaps = initAC;
    var sc = document.createElement("script");
    sc.id = "ao-gmaps";
    sc.async = true;
    sc.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(GOOGLE.apiKey) +
             "&libraries=geometry,places&v=weekly&callback=__aoGmaps";
    sc.onerror = function(){ AC.ready = false; };
    document.head.appendChild(sc);
  }
  function initAC(){
    try{
      google.maps.importLibrary("places").then(function(lib){
        AC.lib = lib; AC.ready = !!(lib && lib.AutocompleteSuggestion);
        if (window.google && google.maps && google.maps.geometry) $("aosegMap").style.display = "";
      })["catch"](function(){ AC.ready = false; });
    }catch(e){ AC.ready = false; }
  }
  function acClose(){
    var b = $("aoaddrSuggest");
    b.classList.remove("open"); b.innerHTML = "";
    AC.sug = []; AC.active = -1;
    $("aoaddr").setAttribute("aria-expanded","false");
  }
  function acFetch(q){
    if (!AC.ready || q.length < 3) return acClose();
    try{
      if (!AC.token && AC.lib.AutocompleteSessionToken) AC.token = new AC.lib.AutocompleteSessionToken();
      AC.lib.AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: q,
        sessionToken: AC.token || undefined,
        includedRegionCodes: [GOOGLE.region],
        locationRestriction: GOOGLE.bounds
      }).then(function(res){
        AC.sug = (res && res.suggestions) || [];
        acRender();
      })["catch"](function(){ acClose(); });
    }catch(e){ acClose(); }
  }
  function acRender(){
    var box = $("aoaddrSuggest"), html = "", n = 0;
    AC.sug.forEach(function(s,i){
      var p = s.placePrediction; if (!p) return;
      var main = (p.mainText && p.mainText.text) || (p.text && p.text.text) || "";
      var sub  = (p.secondaryText && p.secondaryText.text) || "";
      html += '<div class="as-item" data-i="'+i+'" role="option">' + PIN +
              '<span><span class="as-main">'+esc(main)+'</span> <span class="as-sub">'+esc(sub)+'</span></span></div>';
      n++;
    });
    if (!n) return acClose();
    html += '<div class="as-foot">Powered by Google</div>';
    box.innerHTML = html; box.classList.add("open");
    AC.active = -1;
    $("aoaddr").setAttribute("aria-expanded","true");
  }
  function acMove(d){
    var items = $("aoaddrSuggest").querySelectorAll(".as-item");
    if (!items.length) return;
    AC.active = (AC.active + d + items.length) % items.length;
    for (var i=0;i<items.length;i++) items[i].classList.toggle("active", i===AC.active);
  }
  function acChoose(i){
    var s = AC.sug[i]; if (!s || !s.placePrediction) return;
    var p = s.placePrediction;
    try{
      var place = p.toPlace();
      place.fetchFields({ fields:["addressComponents","formattedAddress","location"] }).then(function(){
        acFill(place);
      })["catch"](function(){
        $("aoaddr").value = (p.text && p.text.text) || $("aoaddr").value;
      });
    }catch(e){
      $("aoaddr").value = (p.text && p.text.text) || $("aoaddr").value;
    }
    AC.token = null;
    acClose();
  }
  function acFill(place){
    var c = place.addressComponents || [];
    function get(t){
      for (var i=0;i<c.length;i++){
        var types = c[i].types || [];
        if (types.indexOf(t) >= 0) return c[i].longText || c[i].shortText || "";
      }
      return "";
    }
    function getShort(t){
      for (var i=0;i<c.length;i++){
        var types = c[i].types || [];
        if (types.indexOf(t) >= 0) return c[i].shortText || c[i].longText || "";
      }
      return "";
    }
    var street = ((get("street_number") ? get("street_number") + " " : "") + get("route")).trim();
    $("aoaddr").value = street || place.formattedAddress || $("aoaddr").value;
    $("aoaddr").classList.remove("bad");
    acSetCity(get("locality") || get("sublocality") || get("administrative_area_level_3"),
              getShort("administrative_area_level_1"),
              get("administrative_area_level_2"));
    var zip = get("postal_code");
    if (zip) $("aozip").value = zip;
    if (place.location){
      S.placeLoc = { lat: place.location.lat(), lng: place.location.lng() };
      if (MAP.map) MAP.map.setCenter(S.placeLoc);
    }
    hideErr("aoe1");
  }
  function acSetCity(city, state, county){
    if (!city) return;
    var sel = $("aocity"), msg = $("aoareaMsg"), matched = false;
    for (var i=0;i<sel.options.length;i++){
      if (sel.options[i].text.toLowerCase() === city.toLowerCase()){ sel.selectedIndex = i; matched = true; break; }
    }
    if (!matched) sel.value = "other";
    sel.classList.remove("bad");
    msg.style.display = "block";

    /* Sheboygan County only. A missing county field is NOT treated as a
       rejection - we don't want to turn away a real local address because
       Google omitted it. */
    var outOfState  = state  && state !== GOOGLE.state;
    var outOfCounty = county && county.toLowerCase().indexOf(GOOGLE.county) < 0;
    if (outOfState || outOfCounty){
      S.outOfArea = true;
      msg.innerHTML = "That address is outside Sheboygan County — we're not able to take it on. " +
                      "Call us at (920) 943-6422 if you think that's wrong.";
      sel.classList.add("bad");
      return;
    }
    S.outOfArea = false;
    msg.innerHTML = (SERVICE_CITIES.indexOf(city.toLowerCase()) >= 0)
      ? "✓ " + esc(city) + " is on our route — we service this area."
      : "✓ " + esc(city) + " is in Sheboygan County — we service the whole county.";
  }

  /* ---------------- satellite measure ---------------- */
  var MAP = { map:null, poly:null, drawing:false, listeners:[] };
  var M2_TO_FT2 = 10.7639;

  function setMode(mode){
    S.mode = mode;
    $("aosegCards").classList.toggle("on", mode === "cards");
    $("aosegSqft").classList.toggle("on", mode === "sqft");
    $("aosegMap").classList.toggle("on", mode === "map");
    $("aolots").style.display = mode === "cards" ? "grid" : "none";
    $("aosqftbox").classList.toggle("show", mode === "sqft");
    $("aomapbox").style.display = mode === "map" ? "block" : "none";
    if (mode === "map") initMap();
    buildLots(); render();
  }

  function initMap(){
    if (MAP.map || !(window.google && google.maps && google.maps.Map)) return;
    MAP.map = new google.maps.Map($("aosqMap"), {
      center: S.placeLoc || GOOGLE.center,
      zoom: S.placeLoc ? 20 : 15,
      mapTypeId: "satellite",
      tilt: 0,
      disableDefaultUI: true,
      zoomControl: true,
      gestureHandling: "greedy"
    });
    MAP.map.addListener("click", function(ev){
      if (!MAP.drawing) return;
      addVertex(ev.latLng);
    });
  }

  function mapStartDraw(){
    initMap();
    if (!MAP.map) return;
    mapClear();
    MAP.drawing = true;
    $("aomapRead").innerHTML = "Click each corner of the lawn. Click <b>Draw my lawn</b> again to start over.";
  }

  function addVertex(latLng){
    if (!MAP.poly){
      MAP.poly = new google.maps.Polygon({
        map: MAP.map, paths: [latLng], editable: true, draggable: false,
        strokeColor: "#FFCC33", strokeWeight: 3, fillColor: "#FFCC33", fillOpacity: 0.28
      });
      var path = MAP.poly.getPath();
      ["set_at","insert_at","remove_at"].forEach(function(evt){
        MAP.listeners.push(google.maps.event.addListener(path, evt, measure));
      });
    } else {
      MAP.poly.getPath().push(latLng);
    }
    measure();
  }

  function measure(){
    if (!MAP.poly) return;
    var path = MAP.poly.getPath();
    if (path.getLength() < 3){
      $("aomapRead").textContent = "Keep clicking — a shape needs at least three corners.";
      return;
    }
    var ft2 = google.maps.geometry.spherical.computeArea(path) * M2_TO_FT2;
    S.mapSqft = Math.max(0, Math.round(ft2 / 50) * 50);
    $("aomapRead").innerHTML = "Measured <b>" + sqftTxt(S.mapSqft) + "</b> of lawn. Drag any corner to adjust.";
    render();
  }

  function mapClear(){
    MAP.listeners.forEach(function(l){ google.maps.event.removeListener(l); });
    MAP.listeners = [];
    if (MAP.poly){ MAP.poly.setMap(null); MAP.poly = null; }
    MAP.drawing = false;
    S.mapSqft = null;
    $("aomapRead").textContent = "Type your address above, then trace the grass you want aerated.";
    render();
  }

  /* ---------------- events ---------------- */
  document.addEventListener("click", function(ev){
    var t = ev.target;
    if (!t || !t.closest) return;
    if (!t.closest("#aoapp")) return;   /* stay inside this tool */

    var as = t.closest("#aoaddrSuggest .as-item");
    if (as){ acChoose(parseInt(as.dataset.i,10)); return; }
    if (!t.closest("#aoaddrField")) acClose();

    var pt = t.closest("#aoptype button");
    if (pt){ setPtype(pt.dataset.pt); return; }

    var lot = t.closest("#aolots .lot");
    if (lot){
      var k = lot.dataset.k;
      if (isCom()) S.tierCom = k; else S.tierRes = k;
      setMode("cards");
      return;
    }

    if (t.id === "aosegCards" || t.id === "aosegSqft" || t.id === "aosegMap"){
      setMode(t.dataset.mode); return;
    }

    if (t.id === "aomapDraw"){ mapStartDraw(); return; }
    if (t.id === "aomapClear"){ mapClear(); return; }

    var svc = t.closest(".svc[data-svc]");
    if (svc){
      var sk = svc.dataset.svc;
      if (sk === "aerate")   S.aerate   = !S.aerate;
      if (sk === "overseed") S.overseed = !S.overseed;
      if (sk === "dethatch") S.dethatch = !S.dethatch;
      if (sk === "hydro")    S.hydro    = !S.hydro;
      if (sk === "touchup")  S.touchup  = !S.touchup;
      if (sk === "topdress") S.topdress = !S.topdress;
      if (sk === "irrigate" && S.overseed) S.irrigate = !S.irrigate;
      if (!S.overseed) S.irrigate = false;
      render(); return;
    }

    var go = t.closest("[data-go]");
    if (go){ show(parseInt(go.dataset.go,10)); return; }

    var st = t.closest("#aosteps .st");
    if (st){ show(parseInt(st.dataset.s,10)); return; }

    if (t.id === "aomBtn"){ show(Math.min(3, S.step+1)); return; }
  });

  $("aoaddr").addEventListener("input", function(){
    var q = this.value.trim();
    S.outOfArea = false;
    clearTimeout(AC.timer);
    AC.timer = setTimeout(function(){ acFetch(q); }, 180);
  });
  $("aoaddr").addEventListener("keydown", function(ev){
    if (!$("aoaddrSuggest").classList.contains("open")) return;
    if (ev.key === "ArrowDown"){ ev.preventDefault(); acMove(1); }
    else if (ev.key === "ArrowUp"){ ev.preventDefault(); acMove(-1); }
    else if (ev.key === "Enter" && AC.active >= 0){ ev.preventDefault(); acChoose(AC.active); }
    else if (ev.key === "Escape"){ acClose(); }
  });

  function watch(ids, errId){
    ids.forEach(function(id){
      var el = $(id);
      if (!el) return;
      ["input","change"].forEach(function(evt){
        el.addEventListener(evt, function(){
          this.classList.remove("bad");
          hideErr(errId);
        });
      });
    });
  }
  watch(["aoaddr","aocity","aozip","aosqft"], "aoe1");
  watch(["aofname","aolname","aoemail","aophone","aoseason","aohear"], "aoe3");

  $("aosqft").addEventListener("input", function(){
    var v = parseFloat(this.value);
    S.sqft = (v && v > 0) ? v : null;
    render();
  });

  /* ----------------------------------------------------------------------
     LEAD DELIVERY - identical mechanism to the other two tools.
     Shopify runs captcha protection on every contact form; on a hidden form
     the challenge cannot render, so the handler cancels the submit and never
     resubmits and the lead is dropped in silence. Shopify.captcha.protect
     runs the challenge and calls back with the token in the form; f.submit()
     then bypasses the handler that would cancel us again.
     Klaviyo is the durable record - its client endpoint has no captcha.
     ---------------------------------------------------------------------- */
  function pad(label){ return (label + " ").padEnd ? (label + " ").padEnd(28, ".") : label + " ......"; }
  function leadSummary(p, q, t){
    var L = [];
    L.push("AERATION & OVERSEEDING QUOTE REQUEST — " + p.reference);
    L.push("");
    L.push("Name:      " + (p.first_name + " " + p.last_name).trim());
    L.push("Email:     " + p.email);
    L.push("Phone:     " + p.phone_number);
    L.push("Property:  " + p.address + ", " + p.city + " " + p.zip);
    L.push("Type:      " + (p.property_type === "commercial" ? "COMMERCIAL" : "Residential"));
    L.push("Size:      " + p.size_tier + (q.custom ? "" : " (" + sqftTxt(q.area) + " of turf)"));
    L.push("Window:    " + p.season);
    if (p.heard_from) L.push("Heard via: " + p.heard_from);
    L.push("");
    if (q.custom){
      L.push("ESTIMATE:  Custom quote — 3+ acres, needs a site visit.");
    } else {
      L.push("ESTIMATE" + (q.turf ? " (turf work avg $" + q.rate + " per 1,000 sq ft)" : ""));
      if (q.turf)     L.push("  " + pad(q.turfLabel) + " " + money(q.turf));
      if (q.dethatch) L.push("  " + pad("Dethatching") + " " + money(q.dethatch));
      if (q.topdress) L.push("  " + pad("Compost topdressing") + " " + money(q.topdress));
      if (q.touchup)  L.push("  " + pad("Next-season touch-up") + " " + money(q.touchup));
      if (q.irrigation) L.push("  " + pad("Temporary irrigation") + " " + money(q.irrigation));
      if (q.irrigationQuote) L.push("  " + pad("Temporary irrigation") + " QUOTE ON SITE");
      if (q.save)     L.push("  " + pad("Bundle savings") + " -" + money(q.save));
      L.push("  " + pad("TOTAL") + " " + money(q.total));
    }
    if (q.hydro) L.push("\n*** ALSO WANTS HYDROSEEDING - price this by hand. ***");
    if (p.notes){ L.push(""); L.push("Notes: " + p.notes); }
    L.push("");
    L.push("Marketing opt-in: " + (p.optin ? "yes" : "no"));
    L.push("Submitted from the aeration & overseeding page.");
    return L.join("\n");
  }
  function ssPostForm(id, fields){
    var f = document.getElementById(id);
    if (!f) return false;
    Object.keys(fields).forEach(function(k){
      var el = f.querySelector('[name="' + k + '"]');
      if (el) el.value = fields[k];
    });
    try{
      if (window.Shopify && Shopify.captcha && Shopify.captcha.protect){
        Shopify.captcha.protect(f, function(){ try{ f.submit(); }catch(e){} });
        return true;
      }
    }catch(e){}
    var b = f.querySelector('[type="submit"]');
    if (b){ b.click(); return true; }
    if (f.requestSubmit){ f.requestSubmit(); return true; }
    f.submit();
    return true;
  }
  function ssPhoneE164(p){
    var d = String(p || "").replace(/\D/g, "");
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d.charAt(0) === "1") return "+" + d;
    return null;
  }
  function ssKlaviyo(metricName, p, props){
    if (!KLAVIYO.publicApiKey) return;
    try{
      var prof = { email: p.email, first_name: p.first_name, last_name: p.last_name };
      var e164 = ssPhoneE164(p.phone_number);
      if (e164) prof.phone_number = e164;
      fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(KLAVIYO.publicApiKey), {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({ data: { type: "event", attributes: {
          metric: { data: { type: "metric", attributes: { name: metricName } } },
          properties: props,
          profile: { data: { type: "profile", attributes: prof } }
        } } })
      })["catch"](function(){});
    }catch(e){}
  }
  function sendLead(p, q, t){
    if (!/^https?:$/.test(location.protocol)){
      console.log("(preview mode — lead not sent)\n" + leadSummary(p, q, t));
      return;
    }
    try{
      var tags = "Aeration Lead" + (p.property_type === "commercial" ? ", Commercial" : "") +
                 (p.wants_hydroseed ? ", Hydroseed" : "");

      if (p.optin){
        ssPostForm("ssCustomerForm", {
          "contact[first_name]": p.first_name,
          "contact[last_name]":  p.last_name,
          "contact[email]":      p.email,
          "contact[tags]":       tags
        });
      }

      var sent = ssPostForm("ssLeadForm", {
        "contact[name]":  (p.first_name + " " + p.last_name).trim(),
        "contact[email]": p.email,
        "contact[phone]": p.phone_number,
        "contact[body]":  leadSummary(p, q, t)
      });

      if (!sent){
        var c = new FormData();
        c.append("form_type","contact");
        c.append("utf8","✓");
        c.append("contact[name]", (p.first_name + " " + p.last_name).trim());
        c.append("contact[email]", p.email);
        c.append("contact[phone]", p.phone_number);
        c.append("contact[body]", leadSummary(p, q, t));
        fetch("/contact", { method:"POST", body:c })["catch"](function(){});
      }
    }catch(e){}
  }

  /* ---------------- submit ---------------- */
  $("aosubmit").addEventListener("click", function(){
    if (!validate(3)) return;
    var q = quote();
    var t = currentTier();
    var ref = "AO-" + String(Math.floor(Math.random()*9000)+1000);
    var payload = {
      first_name: $("aofname").value.trim(),
      last_name:  $("aolname").value.trim(),
      email:      $("aoemail").value.trim(),
      phone_number: $("aophone").value.trim(),
      address:    $("aoaddr").value.trim(),
      city:       $("aocity").value,
      zip:        $("aozip").value.trim(),
      property_type: S.ptype,
      size_tier:  S.mode === "sqft" ? "entered sq ft" : t.nm,
      season:     $("aoseason").value,
      heard_from: $("aohear").value,
      notes:      $("aonotes").value.trim(),
      optin:      $("aooptin").checked,
      turf_area_sqft: q.custom ? null : q.area,
      rate_per_1000:  q.custom ? null : q.rate,
      quoted_turf_work: q.custom ? null : q.turf,
      turf_work: q.custom ? null : q.turfLabel,
      quoted_dethatch: q.custom ? null : q.dethatch,
      quoted_topdress: q.custom ? null : q.topdress,
      quoted_touchup:  q.custom ? null : q.touchup,
      quoted_irrigation: q.custom ? null : q.irrigation,
      quoted_bundle_savings: q.custom ? null : q.save,
      quoted_total: q.custom ? null : q.total,
      wants_aeration: S.aerate,
      wants_overseeding: S.overseed,
      wants_dethatching: S.dethatch,
      wants_hydroseed: S.hydro,
      wants_touchup: S.touchup,
      wants_irrigation: S.irrigate && S.overseed,
      wants_topdressing: S.topdress,
      reference: ref,
      source: "aeration-instant-quote"
    };

    sendLead(payload, q, t);
    ssKlaviyo("Aeration Quote Requested", payload, payload);

    if (window.dataLayer) window.dataLayer.push({
      event:"aeration_quote_request", value:payload.quoted_total, reference:ref, property_type:S.ptype
    });

    $("aodoneName").textContent = payload.first_name || "friend";
    $("aodoneRef").textContent = "Reference " + ref;
    var recap = '<div class="item"><span>' + esc(payload.address) + ", " + esc(payload.city) + '</span><span class="amt">' +
                (q.custom ? esc(t.nm) : sqftTxt(q.area)) + '</span></div>' +
                '<div class="item"><span>Property type</span><span class="amt">' + (isCom() ? "Commercial" : "Residential") + '</span></div>';
    if (q.custom){
      recap += '<div class="item"><span><b>Estimate</b></span><span class="amt">Custom quote</span></div>';
    } else {
      if (q.turf)     recap += '<div class="item"><span>' + q.turfLabel + '</span><span class="amt">' + money(q.turf) + '</span></div>';
      if (q.dethatch) recap += '<div class="item"><span>Dethatching</span><span class="amt">' + money(q.dethatch) + '</span></div>';
      if (q.topdress) recap += '<div class="item"><span>Compost topdressing</span><span class="amt">' + money(q.topdress) + '</span></div>';
      if (q.touchup)  recap += '<div class="item"><span>Next-season touch-up</span><span class="amt">' + money(q.touchup) + '</span></div>';
      if (q.irrigation) recap += '<div class="item"><span>Temporary irrigation</span><span class="amt">' + money(q.irrigation) + '</span></div>';
      if (q.irrigationQuote) recap += '<div class="item"><span>Temporary irrigation</span><span class="amt">We\'ll quote it</span></div>';
      if (q.save)     recap += '<div class="item"><span>Bundle savings</span><span class="amt">−' + money(q.save) + '</span></div>';
      recap += '<div class="item"><span><b>Estimate</b></span><span class="amt">' + money(q.total) + '</span></div>';
    }
    if (q.hydro) recap += '<div class="item"><span>Hydroseeding</span><span class="amt">We\'ll quote it</span></div>';
    recap += '<div class="item"><span>Window</span><span class="amt">' + esc(payload.season) + '</span></div>';
    $("aodoneRecap").innerHTML = recap;

    ["ap1","ap2","ap3"].forEach(function(id){ $(id).style.display = "none"; });
    $("apDone").style.display = "block";
    var sts = $("aosteps").children;
    for (var i=0;i<sts.length;i++){ sts[i].classList.add("done"); sts[i].classList.remove("active"); }
    $("aofill").style.width = "100%";
    $("aombar").style.display = "none";
    celebrate();
    var el = document.getElementById("aotool");
    if (el) window.scrollTo({ top: el.offsetTop - 20, behavior:"smooth" });
  });

  function celebrate(){
    try{
      if (window.matchMedia && matchMedia("(prefers-reduced-motion:reduce)").matches) return;
      var box = $("aoconfetti");
      if (!box){
        box = document.createElement("div");
        box.id = "aoconfetti";
        box.setAttribute("aria-hidden","true");
        box.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:5;overflow:hidden";
        document.body.appendChild(box);
      }
      var colors = ["#235029","#4c8a54","#7bbd82","#E0A500","#183a1e"];
      for (var i=0;i<70;i++){
        (function(i){
          var c = document.createElement("i");
          c.style.cssText = "position:absolute;top:-12px;width:9px;height:14px;opacity:.9;" +
            "animation:aofall linear forwards;left:" + (Math.random()*100) + "vw;" +
            "background:" + colors[i % colors.length] + ";" +
            "animation-duration:" + (2.4 + Math.random()*1.8) + "s;" +
            "animation-delay:" + (Math.random()*0.5) + "s;" +
            "transform:rotate(" + (Math.random()*360) + "deg)";
          box.appendChild(c);
          setTimeout(function(){ if (c.parentNode) c.parentNode.removeChild(c); }, 4600);
        })(i);
      }
      if (!document.getElementById("aofall-kf")){
        var st = document.createElement("style");
        st.id = "aofall-kf";
        st.textContent = "@keyframes aofall{to{transform:translateY(105vh) rotate(680deg);opacity:.9}}";
        document.head.appendChild(st);
      }
    }catch(e){}
  }

  buildTowns();
  setPtype("residential");
  $("aosegMap").style.display = "none";   /* revealed once Google Maps loads */
  $("aofill").style.width = "33%";
  loadMaps();
})();
